import React from 'react'
import { useTranslation } from 'react-i18next'
import { ActionIconButton } from '@/components/Elements'
import { useAppConfirmModal } from '@/features/app/hooks'
import { useBillingPaymentMethodDeleteMutation } from '@/features/billing/store'
import { PaymentMethodModel } from '@/features/billing/types'
import { useNotify } from '@/hooks'

interface IProps {
  data: PaymentMethodModel
  onSuccess?: (data: any) => void
}

export const RemoveControl = ({ data }: IProps) => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const [remove, { isLoading }] = useBillingPaymentMethodDeleteMutation()

  const onConfirm = async () => {
    try {
      await remove(data?.id).unwrap()
    } catch (error: any) {
      showNotification({
        type: 'error',
        message: error?.data?.message || t('error'),
      })
    }
  }

  const { open } = useAppConfirmModal({ onConfirm })

  return (
    <>
      <ActionIconButton name={'remove'} onClick={() => open()} disabled={isLoading} />
    </>
  )
}
